/*
 * @Author: Tina Huang
 * @Date: 2024-07-12 09:52:59
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-07-12 10:03:08
 * @Description:
 */

import PickItem from './pick-items'
import { PickType, Picks as picks } from '@/constants/picks'
import useBind from '@/hooks/useBind'
import { Flex } from 'antd'
import { useMemo } from 'react'
export default function Search() {
  const { show: showBind } = useBind()
  // const [libsList, setLibsList] = useState([])
  const libsList: PickType[] = useMemo(() => {
    return picks.filter((item) => !item.hide)
  }, [])
  return (
    <Flex wrap justify="space-between">
      {libsList.map((item) => (
        <PickItem item={item} key={item.id} from={''} onShowBind={() => showBind()} />
      ))}
    </Flex>
  )
}
